import { render, staticRenderFns } from "./DialogAstaRosa.vue?vue&type=template&id=f74cd9f4&scoped=true&"
import script from "./DialogAstaRosa.vue?vue&type=script&lang=js&"
export * from "./DialogAstaRosa.vue?vue&type=script&lang=js&"
import style0 from "./DialogAstaRosa.vue?vue&type=style&index=0&id=f74cd9f4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f74cd9f4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/diego/Desktop/code/asta-live/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f74cd9f4')) {
      api.createRecord('f74cd9f4', component.options)
    } else {
      api.reload('f74cd9f4', component.options)
    }
    module.hot.accept("./DialogAstaRosa.vue?vue&type=template&id=f74cd9f4&scoped=true&", function () {
      api.rerender('f74cd9f4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dialogs/DialogAstaRosa.vue"
export default component.exports